import { useState, useEffect } from 'react'

const useSendDataToClarity = () => {
  const [isClarityLoaded, setIsClarityLoaded] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.clarity && typeof window.clarity === 'function') {
        setIsClarityLoaded(true)
      }
    }, 100)

    setTimeout(() => {
      clearInterval(interval)
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (key, value) => {
    isClarityLoaded && window.clarity('set', key, value)
  }
}

export default useSendDataToClarity
